import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { PlayerPlacement } from 'enums';
import WatchPropTypes from 'common/PropTypes';
import { isContentLocked } from 'lib/auth';
import { isEmpty } from 'lib/util';
import { isIntlSelector, dateFormatSelector } from 'common/selectors/appSelector';
import heroSelector from 'common/selectors/heroSelector';
import selectedStreamSelector from 'common/selectors/selectedStreamSelector';
import playingStreamSelector from 'common/selectors/playingStreamSelector';
import {
    userLocationSelector,
    userAuthSelector,
    preauthorizedResourcesSelector
} from 'common/selectors/authenticationSelectors';
import BannerAd from 'common/ads/BannerAd';
import BrandingContainer from 'webapp/branding/BrandingContainer';
import ContentMetadataLarge from 'common/page/hero/ContentMetadataLarge';
import HeroPlaybackPage from './HeroPlaybackPage';
import { contentSubtitle } from '@alias/lib/format';

const formatVideoTitle = (currentContent, currentStream) => {
    let title = currentContent.name;

    if (currentContent && currentStream) {
        if (currentContent.isEvent) {
            if (currentContent.streams && currentContent.streams.length > 1) {
                if (currentStream.authTypes && currentStream.authTypes.indexOf('direct') !== -1) {
                    title = currentContent.name;
                } else {
                    title = currentStream.name !== currentContent.name ? currentStream.name : currentContent.name;
                }
            } else {
                // Single event stream
                title = currentContent.name;
            }
        }
    }

    return title;
};

const HeroPlaybackPageContainer = ({
    alertContent,
    content,
    stream,
    location,
    placement,
    bucketId,
    bucketName,
    pageId,
    pageName,
    userInitiated,
    showLock,
    userLocation,
    isIntl,
    intlDateFormat
}) => {
    const { description } = content;
    const title = formatVideoTitle(content, stream);
    const streamSubtitle = stream && stream.content && stream.content.subtitle;
    // Use the current stream content and sanitize the text; default to the content subtitle
    const formattedSubtitle = streamSubtitle || contentSubtitle(content);
    let subtitle = formattedSubtitle; // for VOD, this will be null and render nothing
    if (formattedSubtitle && description) {
        subtitle = `${formattedSubtitle} - ${description}`;
    }
    const bannerAd = isIntl ? <BannerAd exclude={['l', 'xl']} /> : null;

    return (
        <div className="playback__columnA">
            <figure className="playback__media">
                <BrandingContainer location={location} stream={stream} />
                <HeroPlaybackPage
                    alertContent={alertContent}
                    disableAuthPrompt={false}
                    initialAutoEmbedCountDown={0}
                    location={location}
                    playerPlacement={PlayerPlacement.PLAYER}
                    placement={placement}
                    bucketId={bucketId}
                    bucketName={bucketName}
                    pageId={pageId}
                    pageName={pageName}
                    userInitiated={userInitiated}
                    userLocation={userLocation}
                    dateFormat={intlDateFormat}
                />
                <ContentMetadataLarge
                    showLock={showLock}
                    title={title}
                    subtitle={subtitle}
                    content={content}
                />
            </figure>
            {bannerAd}
        </div>
    );
};

HeroPlaybackPageContainer.propTypes = {
    alertContent: WatchPropTypes.content,
    content: WatchPropTypes.content,
    stream: WatchPropTypes.stream,
    location: PropTypes.object,
    placement: PropTypes.string,
    bucketId: PropTypes.number,
    bucketName: PropTypes.string,
    pageId: PropTypes.string,
    pageName: PropTypes.string,
    userInitiated: PropTypes.bool,
    showLock: PropTypes.bool,
    userLocation: PropTypes.object,
    isIntl: PropTypes.bool,
    intlDateFormat: PropTypes.string
};

HeroPlaybackPageContainer.defaultProps = {
    adobePass: {},
    content: {}
};

const mapStateToProps = (state) => {
    const userAuth = userAuthSelector(state);
    const preauthorizedResources = preauthorizedResourcesSelector(state);
    const selectedStream = selectedStreamSelector(state);
    const playingStream = playingStreamSelector(state);
    const stream = !isEmpty(playingStream) ? playingStream : selectedStream;
    // TODO: DTC - use `stream.content` once `content` has `duration` for VOD
    // so that content metadata doesn't change every time when a new content is selected when user is not authed
    const content = /* stream ? stream.content : */heroSelector(state);
    return {
        content,
        stream,
        isIntl: isIntlSelector(state),
        intlDateFormat: dateFormatSelector(state),
        userAuth,
        userLocation: userLocationSelector(state),
        showLock: isContentLocked(content, userAuth, preauthorizedResources)
    };
};

export default connect(mapStateToProps)(HeroPlaybackPageContainer);



// WEBPACK FOOTER //
// ./app/webapp/page/hero/HeroPlaybackPageContainer.js